// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLoader_skeleton__V+i72","pulse":"SkeletonLoader_pulse__9K8GI","shine":"SkeletonLoader_shine__4OPWd"};